import { InvoiceBasicModel, InvoiceDocTypeModel, InvoiceInternalModel, InvoiceModel } from "@shared/models";
import { FormatDatesService } from "@shared/services";
import { Employee           } from "@shared/factories";

export class InvoiceBasic {
  id:       number;
  subject:  string;
  filename: string;
  docType:  InvoiceDocTypeModel;
  constructor(data: InvoiceBasicModel) {
    this.id       = data.id       ? data.id       : null;
    this.subject  = data.subject  ? data.subject  : null;
    this.filename = data.filename ? data.filename : null;
    this.docType  = data.doc_type ? data.doc_type : null;
  }

  toJSON(): InvoiceBasicModel {
    return ({
      id:       this.id       ? this.id       : null,
      subject:  this.subject  ? this.subject  : null,
      filename: this.filename ? this.filename : null,
      doc_type: this.docType  ? this.docType  : null,
    });
  }

}

export class InvoiceInternal extends InvoiceBasic {
  createdAt:      Date;
  externalReadAt: Date;
  documentUrl:    string;
  constructor(data: InvoiceInternalModel) {
    super(data);
    this.createdAt      = FormatDatesService.parseDate(data.created_at);
    this.externalReadAt = FormatDatesService.parseDate(data.external_read_at);
    this.documentUrl    = data.document_url ? data.document_url : null;
  }

  toJSON(): InvoiceInternalModel {
    return Object.assign(super.toJSON(), {
      created_at:       FormatDatesService.parseDateISO(this.createdAt),
      external_read_at: FormatDatesService.parseDateISO(this.createdAt),
      document_url:     this.documentUrl ? this.documentUrl : null,
    });
  }

}
export class Invoice extends InvoiceBasic {
  doc_type_name:  string;
  company_number: number;

  customerReadAt: Date;

  pdfAttached:    boolean;
  xmlAttached:    boolean;

  invoice_date:   Date;
  archived_at:    Date;
  archived_by:    Employee;
  constructor(data: InvoiceModel) {
    super(data);

    this.doc_type_name  = data.doc_type.name;
    this.company_number = data.company_number;

    this.customerReadAt = FormatDatesService.parseDate(data.customer_read_at);

    this.pdfAttached    = data.document_attached;
    this.xmlAttached    = data.electronic_invoice_attached;

    this.invoice_date   = FormatDatesService.parseDate(data.invoice_date);
    this.archived_at    = FormatDatesService.parseDate(data.archived_at);
    this.archived_by    = data.archived_by ? new Employee(data.archived_by) : null;
  }

  toJSON(): InvoiceModel {
    return Object.assign(super.toJSON(), {
      company_number:              this.company_number,
      document_attached:           this.pdfAttached,
      electronic_invoice_attached: this.xmlAttached,

      customer_read_at:            this.customerReadAt ? FormatDatesService.parseDateISO(this.customerReadAt) : null,
      invoice_date:                this.invoice_date   ? FormatDatesService.parseDateISO(this.invoice_date)   : null,
      archived_at:                 this.archived_at    ? FormatDatesService.parseDateISO(this.archived_at)    : null,
      archived_by:                 this.archived_by    ? this.archived_by.toJSON()                            : null,
    });
  }

}
